import { Branded } from 'types/generics/brand'
import { RichTextContent } from 'types/richText/types'
import {
  EntryID,
  RolodexEntryIndexType,
  RolodexEntryJson,
} from 'types/rolodex/rolodexEntries'
import { parseBoolean, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * A type specification for the case
 * The type options may come from the site config
 */
export type CaseType = Branded<string, 'CaseType'>

/**
 * A type specification for the case status
 * The status options may come from the site config
 */
export type CaseStatus = Branded<string, 'CaseStatus'>

/**
 * The properties describing the case
 * This should be specified as a JSON schema on the site config
 */
type CaseMetadata = Record<string, string | number | boolean>

export type GeckoCaseData = {
  case_title: string
  case_type: CaseType
  case_status: CaseStatus
  is_published: boolean
  case_metadata: CaseMetadata
  content: RichTextContent
  supplementary_links: EntryID[] // Entries linked to the case separate from what's present in content
}

export class GeckoCase extends GeckoEntryBase<
  GeckoCaseData,
  {
    organization: string
    site: string
  },
  RolodexEntryIndexType
> {
  constructor(json: RolodexEntryJson) {
    const data = {
      case_title: parseString(json.data.case_title) ?? '',
      case_type: parseString(json.data.case_type) as CaseType,
      case_status: parseString(json.data.case_status) as CaseStatus,
      is_published: parseBoolean(json.data.is_published) ?? false,
      case_metadata: json.data.case_metadata as CaseMetadata,
      content: parseString(json.data.content) as RichTextContent,
      supplementary_links: json.data.supplementary_links as EntryID[],
    }
    const tags = {
      organization: parseString(json.tags.organization) ?? '',
      site: parseString(json.tags.site) ?? '',
    }
    super(json, data, tags, {})
  }
}
